module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/2@2x_cc3138c35cec9e8da9f993845653ba7b.png";